import { useSummary } from '@composables/common'
import { NyalaCustomer } from '@src/types/NyalaCustomer'
import { SummaryItem } from '@src/types/Summary'
import { computed, Ref } from 'vue'
import { useI18n } from 'vue-i18n'

export function useNyalaCustomerSummary(
    nyalaCustomer: Ref<NyalaCustomer | null>
) {
    const i18n = useI18n()

    const items = computed<SummaryItem[]>(() => {
        return [
            {
                label: i18n.t('kyc_data_transfered'),
                value: nyalaCustomer.value?.kyc_data_transfered,
                special: 'check',
                condition: nyalaCustomer.value !== null,
            },
            {
                label: i18n.t('external_customer_id'),
                value: nyalaCustomer.value?.external_customer_id ?? '',
                condition: nyalaCustomer !== null,
                copy: true,
            },
            {
                label: i18n.t('public_address'),
                value: nyalaCustomer.value?.public_address ?? '',
                condition: nyalaCustomer !== null,
                copy: true,
            },
            {
                label: i18n.t('retail_wallet_id'),
                value: nyalaCustomer.value?.retail_wallet_id ?? '',
                condition: nyalaCustomer !== null,
                copy: true,
            },
            {
                label: i18n.t('retail_wallet_status'),
                value: nyalaCustomer.value?.retail_wallet_status ?? '',
                condition: nyalaCustomer !== null,
                copy: true,
            },
        ]
    })

    const { Summary: NyalaCustomerSummary } = useSummary(items, {
        title: 'nyala_customer',
    })

    return {
        NyalaCustomerSummary,
    }
}
